var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Hitbox = function (left, right, top, bottom, color) {
  EHDI.aka.Container.call(this);

  if (typeof left !== 'number' || typeof right !== 'number' ||
  typeof top !== 'number' || typeof bottom !== 'number')
      throw new Error('Invalid Hitbox Parameter');

  this.init(left, right, top, bottom);
  this.addGraphics(color);
};

EHDI.game.Hitbox.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Hitbox.prototype.init = function (left, right, top, bottom) {
  this._left = left;
  this._right = right;
  this._top = top;
  this._bottom = bottom;

  this._width = left + right;
  this._height = top + bottom;
  this._halfWidth = this._width / 2;
  this._halfHeight = this._height / 2;
  this._centerX = this._halfWidth - left;
  this._centerY = this._halfHeight - top;

  this._updatedCenterX = 0;
  this._updatedCenterY = 0;
  this._globalLeftX = 0;
  this._globalRightX = 0;
  this._globalTopY = 0;
  this._globalBottomY = 0;
};

EHDI.game.Hitbox.prototype.addGraphics = function (color) {
  this._graphics = new EHDI.aka.Graphics();

  this._graphics.beginFill(color);
  this._graphics.drawRect(-this._left, -this._top, this._left + this._right,
    this._top + this._bottom);
  this._graphics.endFill();

  this.addChild(this._graphics);
};

EHDI.game.Hitbox.prototype.update = function (newX, newY) {
  this._updatedCenterX = newX + this._centerX;
  this._updatedCenterY = newY + this._centerY;

  this._globalLeftX = this._updatedCenterX - this._halfWidth;
  this._globalRightX = this._updatedCenterX + this._halfWidth;
  this._globalTopY = this._updatedCenterY - this._halfHeight;
  this._globalBottomY = this._updatedCenterY + this._halfHeight;
};

EHDI.game.Hitbox.prototype.getGlobalLeftX = function () {
  return this._globalLeftX;
};

EHDI.game.Hitbox.prototype.getGlobalRightX = function () {
  return this._globalRightX;
};

EHDI.game.Hitbox.prototype.getGlobalTopY = function () {
  return this._globalTopY;
};

EHDI.game.Hitbox.prototype.getGlobalBottomY = function () {
  return this._globalBottomY;
};

EHDI.game.Hitbox.prototype.getWidth = function () {
  return this._width;
};

EHDI.game.Hitbox.prototype.getHeight = function () {
  return this._height;
};
